<template>
    <div style="margin-top: -10px;">
        <a-row :gutter="[48,0]">
    <a-col :span="8">
        <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            Query Type:
        </a-col>
        <a-col :span="16">
            <a-select v-model="queryType" placeholder="Select query type" style="width: 100%;" :options="queryTypeList">
            </a-select>
        </a-col>
        </a-row>
    
    <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            Query Name:
        </a-col>
        <a-col :span="16">
            <a-auto-complete
                v-if="queryType=='Gene_name'"
                ref="geneInput"
                v-model="geneName"
                :data-source="geneList"
                @search="handleSearch"
                placeholder="input gene name"
                style="width: 100%;"
                :class="{ 'shake': error }"
            />
            <a-auto-complete
                v-if="queryType=='circRNA_ID'"
                ref="geneInput"
                v-model="geneName"
                placeholder="input circRNA ID"
                style="width: 100%;"
                :class="{ 'shake': error }"
            />
            <div v-if="error" class="error-message">{{ error }}</div>
        </a-col>
    </a-row>

    <a-row :gutter="[0,24]">
        <a-col :span="8" class="param-text">
            Show circRNA seq:
        </a-col>
        <a-col :span="16">
            <a-switch  v-model="showCircRNASeq"/>
        </a-col>
    </a-row>
    
    <a-row :gutter="[0,24]">
        <a-col :span="24">
            <a-button @click="handleAnalysis">Start analysis</a-button>
        </a-col>
    </a-row>
    <a-row :gutter="[0,24]">
        <a-col :span="8">
            <a-button icon="download" :loading="loading" @click="handleDownload('api/download/' + Table_Url)" style="margin: auto 0;" type="primary">Table</a-button>
        </a-col>
    </a-row>

    </a-col>
    <a-col :span="16">
        <div>
        <a-tabs default-active-key="1" tabPosition="bottom" style="width: 100%;">
            <a-tab-pane key="3" tab="Table">
            <div class="content" style="padding: 10px">
                <a-icon v-show="loading" class="placeholder" style="font-size:50px;" type="loading" />
                <data-table v-show="!loading && Table_Url" :data="tableData" :scroll-y="455"/>
                <div v-if="!loading && !Table_Url" class="placeholder">Failed, please retry.</div>
            </div>
            </a-tab-pane>
        </a-tabs>
        </div>
        
    </a-col>
    </a-row>
    </div>
</template>
    
<script>
import { downloadFile } from '@/utils';
import api from '@/api';
import XLSX from 'xlsx';
import Papa from 'papaparse';
import DataTable from '@/components/DataTable.vue';
import AllGeneList from './AllGeneList.js';
import { v4 as uuidv4 } from 'uuid';

export default {
    // inject: ['uuid'],
    name: 'CircRnaQueryRnaInfomation',
components: {
    DataTable
},
    data() {
    return {
    uuid: uuidv4(),
    error: null,  // 错误信息
    geneName: "COG5",
    geneList: [],
    loading: false,
    queryType: 'Gene_name',
    queryTypeList: [
        {value:'circRNA_ID', label: 'circRNA ID'},
        {value:'Gene_name', label: 'Gene Name'}
    ],
    showCircRNASeq: false,
    Table_Url: 'output/sample/circrna/Query_circRNA_information.xlsx',
    tableData: []   // 表格数据
    };
},
created() {
    this.loadTableDataXlsx(this.Table_Url)
},
    methods: {
    handleDownload(url) {
      downloadFile(url);
    },
    onPdf1Loaded() {
        // this.$nextTick(() => {
        //   const canvas = this.$refs.pdf1Component.$el.querySelector('canvas');
        //   if (canvas) {
        //     setTimeout(() => {
        //       const actualWidth = canvas.width; 
        //       const actualHeight = canvas.height; 
        //       const aspectRatio = actualWidth / actualHeight;
        //       this.resizedWidth1 = 480 * aspectRatio;
        //     }, 10);
        //   }
        // });
    },
    onPdf2Loaded() {
        // this.$nextTick(() => {
        //   const canvas = this.$refs.pdf2Component.$el.querySelector('canvas');
        //   if (canvas) {
        //     setTimeout(() => {
        //       const actualWidth = canvas.width; 
        //       const actualHeight = canvas.height; 
        //       const aspectRatio = actualWidth / actualHeight;
        //       this.resizedWidth2 = 480 * aspectRatio;
        //     }, 10);
        //   }
        // });
    },
    handleAnalysis() {
        const validPrefix = 'hsa_circ'
        if (this.queryType === 'circRNA_ID') {
            if (!this.geneName.startsWith(validPrefix)) {
                this.error = `Query ID must start with '${validPrefix}'`;
                this.$refs.geneInput.focus();
                const element = this.$refs.geneInput.$el;
                element.classList.remove('shake');  // 先移除类
                void element.offsetWidth;           // 触发重绘
                element.classList.add('shake');     // 再添加类
                return;
            }
        }
        if (this.queryType === 'Gene_name') {
            if (this.geneName.startsWith(validPrefix)) {
                this.error = `Gene name must not start with '${validPrefix}'`;
                this.$refs.geneInput.focus();
                const element = this.$refs.geneInput.$el;
                element.classList.remove('shake');  // 先移除类
                void element.offsetWidth;           // 触发重绘
                element.classList.add('shake');     // 再添加类
                return;
            }
        }

        
        this.error = null;

        this.loading = TextTrackCue
        api.post('/analysis/r', {uuid: this.uuid, category: "circrna", tool: "Query_circRNA_information", param: {query_type: this.queryType, query_name: this.geneName, show_circRNA_seq: this.showCircRNASeq}})
        .then(response => {
            this.Table_Url = this.findStringsEndingWith(response.data, "Query_circRNA_information.xlsx").slice(11) + '?timestamp=' + Date.now()
            this.loadTableDataXlsx(this.Table_Url)
            this.loading = false
        })
        .catch(error => {
            console.error('Error occurred:', error);
            this.Table_Url = ""
            this.tableData = []
            this.loading = false
            // 在这里处理请求错误
        });
        },
    // 加载并解析XLSX文件
    loadTableDataXlsx(tableUrl) {
        api.get('/download/' + tableUrl, { responseType: 'arraybuffer' })
        .then(response => {
        const data = new Uint8Array(response);
        const workbook = XLSX.read(data, { type: 'array' });

        // 假设要读取第一个工作表
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // XLSX.utils.sheet_to_json 返回一个对象数组，与PapaParse的输出类似
        this.tableData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (this.tableData.length > 0) {
            // 提取表头
            const headers = this.tableData[0];
            // 使用表头创建每行的数据对象
            this.tableData = this.tableData.slice(1).map(row => {
            return headers.reduce((obj, header, index) => {
                obj[header] = row[index];
                return obj;
            }, {});
            });
        }
        })
        .catch(error => {
        console.error('获取XLSX文件出错:', error);
        });
    },
    // 加载并解析CSV文件
    loadTableDataCsv(tableUrl) {
        api.get(/download/ + tableUrl)
        .then(response => {
            Papa.parse(response, {
            header: true, // 第一行作为表头
            skipEmptyLines: true,
            complete: results => {
                this.tableData = results.data;
            },
            error: (error) => {
                console.error('CSV解析错误:', error);
            }
            });
        })
        .catch(error => {
            console.error('获取CSV文件出错:', error);
        });
    },
    findStringsEndingWith(stringsArray, ending) {
        const foundString = stringsArray.find(str => str.endsWith(ending));
        return foundString || '';
    },
    handleSearch(value) {
      if (value) {
        this.geneList = AllGeneList.filter(item => 
            item.toLowerCase().startsWith(value.toLowerCase())
        ).slice(0, 10)
      } else {
        this.geneList = [];
      }
    },
    },
};
</script>

<style scoped>
.content {
height: 520px; /* 占据空间 */
}
.placeholder {
min-height: 480px;
display: flex;
justify-content: center;
align-items: center;
color: #999;
}

.param-text {
font-size: 14px;
font-weight: 600;
margin-top: 5px;
}

.error-message {
    position: absolute;
    top: 42px; /* Adjust this value based on the height and padding of the input */
    left: 0;
    color: red;
    visibility: visible;
}

.shake {
  animation: shake 0.5s linear;
}

@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}
</style>

<style>
.parent-tabs > .ant-tabs-bar .ant-tabs-tab {
font-size: 16px !important; /* 增大字体 */
background-color: #f0f2f5 !important; /* 未选中标签的背景色 */
color: #1890ff !important; /* 未选中标签的文字色 */
border: 1px solid #d9d9d9 !important; /* 标签的边框 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab-active {
background-color: #1890ff !important; /* 选中标签的背景色 */
color: #fff !important; /* 选中标签的文字色 */
border-color: #1890ff !important; /* 选中标签的边框色 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab:hover {
color: #40a9ff !important; /* 悬停时的文字色 */
}

.parent-tabs > .ant-tabs-bar .ant-tabs-tab + .ant-tabs-tab {
margin-left: 4px !important; /* 调整标签之间的间距 */
}

</style>